import React, { useEffect, useState } from "react";
import ModalScreen from "../common/ModalScreen";

export const OFFER_EXCEL_INTERNAL_FIELDS = [
  { value: "reference", label: "Referência" },
  { value: "stock", label: "Stock" },
  { value: "cost_1", label: "Custo IAPC" },
  { value: "cost_2", label: "Custo 2" },
  { value: "our_proposal", label: "Nossa proposta" },
  { value: "local_rev3", label: "REV3 IAPC" },
  { value: "rev3", label: "REV3" },
  { value: "pvp_without_vat", label: "PVP sem IVA" },
  {
    value: "show_individual_pvp_without_vat",
    label: "Mostrar PVP sem IVA individual",
  },
] as const;

export type OfferExcelInternalField =
  (typeof OFFER_EXCEL_INTERNAL_FIELDS)[number]["value"];

export const defaultOfferExcelInternalFields = (): OfferExcelInternalField[] =>
  OFFER_EXCEL_INTERNAL_FIELDS.filter(
    ({ value }) => value !== "show_individual_pvp_without_vat",
  ).map(({ value }) => value);

const OfferExcelExportModal = ({
  open,
  exporting,
  onClose,
  onExport,
}: {
  open: boolean;
  exporting: boolean;
  onClose: () => void;
  onExport: (fields: OfferExcelInternalField[]) => void;
}) => {
  const [selectedFields, setSelectedFields] = useState<
    OfferExcelInternalField[]
  >(defaultOfferExcelInternalFields);

  useEffect(() => {
    if (open) setSelectedFields(defaultOfferExcelInternalFields());
  }, [open]);

  if (!open) return null;

  const toggleField = (field: OfferExcelInternalField) => {
    setSelectedFields((current) =>
      current.includes(field)
        ? current.filter((value) => value !== field)
        : [...current, field],
    );
  };

  return (
    <ModalScreen
      title="Exportar proposta para Excel"
      state="confirm"
      onClose={onClose}
      footer={
        <div className="flex justify-end gap-2 p-4">
          <button className="button" onClick={onClose} disabled={exporting}>
            Cancelar
          </button>
          <button
            className="button is-success"
            onClick={() => onExport(selectedFields)}
            disabled={exporting}
          >
            {exporting ? "A exportar..." : "Exportar Excel"}
          </button>
        </div>
      }
    >
      <div className="p-6">
        <p className="mb-4">
          Selecione os campos internos adicionais a incluir no ficheiro.
        </p>
        <div className="space-y-3">
          {OFFER_EXCEL_INTERNAL_FIELDS.map((field) => (
            <label key={field.value} className="checkbox block">
              <input
                type="checkbox"
                checked={selectedFields.includes(field.value)}
                onChange={() => toggleField(field.value)}
                disabled={exporting}
              />
              <span className="ml-2">{field.label}</span>
            </label>
          ))}
        </div>
      </div>
    </ModalScreen>
  );
};

export default OfferExcelExportModal;
